module.exports = __webpack_public_path__ + "img/he6.d5a0edeb.png";